<template>
  <div class="agreement">
    <a-modal
      :dialog-style="{ top: '11.01vh',bottom:'11.01vh' }"
      :visible="visible"
      destroyOnClose
      :footer="null"
      :width="'46.875vw'"
      @cancel="visible = false"
    >
      <template slot="title">
        <div class="title-box">
          <img src="@/assets/login/12.png">
          <span class="font16R" style="color: #333;">{{ title }}</span>
        </div>
      </template>
      <div class="agreementClass" v-html="content"></div>
    </a-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      title: '',
      content: '注册协议内容注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容注册协议内容注册协议内容；注册协议内容注册协议内容注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容；注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容注册协议注册协议内容注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容注册协议内容注册协议内容；注册协议内容注册协议内容注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容；注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容注册协议注册协议内容注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容注册协议内容注册协议内容；注册协议内容注册协议内容注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容；注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容注册协议注册协议内容注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容注册协议内容注册协议内容；注册协议内容注册协议内容注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容；注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容注册协议注册协议内容注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容注册协议内容注册协议内容；注册协议内容注册协议内容注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容；注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容注册协议注册协议内容注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容注册协议内容注册协议内容；注册协议内容注册协议内容注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容；注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容注册协议注册协议内容注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容注册协议内容注册协议内容；注册协议内容注册协议内容注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容；注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容注册协议注册协议内容注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容注册协议内容注册协议内容；注册协议内容注册协议内容注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容；注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容注册协议注册协议内容注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容注册协议内容注册协议内容；注册协议内容注册协议内容注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容；注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容，注册协议内容注册协议内容。注册协议内容注册协议内容注册协议内容注册协议内容注册协议'
    }
  },
  created() {
  },
  methods: {
    init(title) {
      this.title = title
      this.visible = true
    }
  }
}
</script>

<style lang="less" scoped>
.title-box {
  display: flex;
  align-items: center;
  position: relative;
  padding: 5px 8px 3px;
  img {
    width: 3px;
    height: 14px;
    margin-right: 8px;
  }
}

.agreementClass {
  padding: 0 8px;
  max-height: 65.18vh;
  overflow-y: auto;
  margin-bottom: 34px;
}
</style>
